import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/FileViewer/FileViewer.styled.ts";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var IconButton = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 20px;\n  background-color: transparent;\n  border: none;\n  border-radius: 50%;\n  cursor: pointer;\n  filter: drop-shadow(0 2px 2px #1a1a1a);\n  z-index: 1;\n"])));